/**
 * Mixin pour charger la bibliothèque Video.js de manière asynchrone
 * uniquement lorsque les composants vidéo sont utilisés
 */
export default {
  data() {
    return {
      videoJsLoaded: false,
      videoJsLoading: false,
      videoJsError: null
    };
  },
  methods: {
    /**
     * Charge Video.js depuis la CDN si ce n'est pas déjà fait
     * @returns {Promise} Une promesse qui se résout lorsque Video.js est chargé
     */
    loadVideoJs() {
      // Si Video.js est déjà chargé, on renvoie une promesse résolue
      if (typeof window.videojs !== 'undefined' || this.videoJsLoaded) {
        return Promise.resolve();
      }

      // Si Video.js est en cours de chargement, on renvoie la promesse en cours
      if (this.videoJsLoading) {
        return new Promise((resolve, reject) => {
          const checkLoaded = () => {
            if (this.videoJsLoaded) {
              resolve();
            } else if (this.videoJsError) {
              reject(this.videoJsError);
            } else {
              setTimeout(checkLoaded, 100);
            }
          };
          checkLoaded();
        });
      }

      // Sinon, on charge Video.js
      this.videoJsLoading = true;

      return new Promise((resolve, reject) => {
        // Chargement de la CSS
        const cssLink = document.createElement('link');
        cssLink.rel = 'stylesheet';
        cssLink.href = 'https://vjs.zencdn.net/6.11.0/video-js.css';
        document.head.appendChild(cssLink);

        const originalDefine = window.define;
        if (typeof originalDefine === 'function' && originalDefine.amd) {
          window.define = undefined;
        }

        // Chargement du JS
        const script = document.createElement('script');
        script.src = 'https://vjs.zencdn.net/6.11.0/video.min.js';
        script.async = true;

        script.onload = () => {
          if (originalDefine) {
            window.define = originalDefine;
          }

          this.videoJsLoaded = true;
          this.videoJsLoading = false;
          resolve();
        };

        script.onerror = (error) => {
          if (originalDefine) {
            window.define = originalDefine;
          }

          console.error('Erreur lors du chargement de Video.js:', error);
          this.videoJsError = error;
          this.videoJsLoading = false;
          reject(error);
        };

        document.head.appendChild(script);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/VideoPlayerMixin.js